import type { IBrandConfig } from './types';

const PRIVACY_ASSIST_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'external',
    url: 'https://www.pango.co/privacy-policy',
  },
  termsOfService: { kind: 'cms', path: 'policy/tou/privacy-assist-terms.md' },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'intersections',
  // Don't have vault project
  vaultProject: 'identityguard_watson',
  adaChat: true,
  defaultBillingCategoryKey: 'identityguard_fi',
  copyRightEntity: 'Intersections LLC dba Pango',
  carouselBanners: true,
  /* Angular admits Privacy Assist to the Ultimate banners on product-change
     eligibility alone — no DTC / retail-cc-billed requirement — and does not
     give it the Family banner (`dashboard-carousel.component.ts:134`, `:152`). */
  planUpgradeBanners: {
    ultimate: true,
    family: false,
    requireRetailDtc: false,
  },
  /* Excluded from the critical-notification upsell banner
     (`critical-notifications.component.ts:110`). */
  upsellBanner: false,
  security: true,
  finishSetup: false,
  hasCustomerServiceSupport: true,
  headerPhone: true,
  secureUpload: true,
  accountDetails: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default PRIVACY_ASSIST_BRAND_CONFIG;
